<script>
import {vMaska} from "maska";

export default {
  name: "RegPwd",
  data() {
    return {
      email: '',
      uniqueCode: '',
      newPw: '',
      newPw2: '',
      showResetPwOptions: false,
      actionButton: true
    }
  },
  directives: {maska: vMaska},
  methods: {
    async requestPwActionsExecute() {
      try {
        if (this.validEmail() && !this.showResetPwOptions) {
          let data = {email: this.email}
          let result = await this.$api.post("/password/request", data, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          });
          if (result.status === 200) {
            this.showResetPwOptions = true
            this.$swal.fire({
              icon: 'info',
              title: 'Revise su correo electronico',
              text: 'Se ha enviado un codigo para establecer una nueva contraseña',
              customClass: {
                popup: 'mySwal'
              }
            })
          }
        } else {
          if (this.showResetPwOptions && this.newPw === this.newPw2) {
            let data = {email: this.email, uniqueCode: this.uniqueCode, newPw: this.newPw}
            let result = await this.$api.post("/password/set", data, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            });
            if (result.status.toString() === "202") {
              await this.$router.push("/")
              this.$swal.fire({
                icon: 'success',
                title: 'Contraseña guardada exitosamente',
                text: '',
                customClass: {
                  popup: 'mySwal'
                }
              })
            }
          }
        }
      } catch (error) {
        if (!this.showResetPwOptions) {
          this.$swal.fire({
            icon: 'warning',
            title: 'Usuario no encontrado',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'Credenciales invalidas',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          })
        }
      }

    },
    restrictEmailStringInput() {
      this.email = this.email.replace(/[^\w.@-]| /g, '')
      this.email = this.email.toLowerCase()
      const atSymbolIndex = this.email.indexOf('@')
      if (atSymbolIndex !== -1) {
        this.email = this.email.slice(0, atSymbolIndex + 1) + this.email.slice(atSymbolIndex + 1).replace(/@/g, '')
      }
      while (this.email.includes('..')) {
        this.email = this.email.replace('..', '.')
      }
    },
    restrictUniqueCodeInput() {
      if (this.uniqueCode.length > 8) {
        this.uniqueCode = this.uniqueCode.slice(0, 8);
      }

      this.uniqueCode = this.uniqueCode.replace(/[^a-zA-Z0-9]/g, '');

    },
    validEmail() {
      // eslint-disable-next-line no-useless-escape
      return /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(this.email);

    },
    isButtonActive() {
      if (!this.showResetPwOptions) {
        this.actionButton = !this.validEmail()
      } else {
        this.actionButton = !(this.validPw(this.newPw) && this.validPw(this.newPw2) && this.newPw === this.newPw2)
      }

    },
    validPw(password) {
      let number = false
      let upper = false
      let lower = false
      let special = false
      let length = false

      number = /\d/.test(password)

      upper = /[A-Z]/.test(password)

      lower = /[a-z]/.test(password)

      // eslint-disable-next-line no-useless-escape
      special = /[~!@#$%^&*()_+\-=\[\]{};':"\\|,.<>?]/.test(password)

      length = password.length >= 10

      // eslint-disable-next-line no-useless-escape
      return number && upper && lower && special && length && lower
    },
    removeSpace() {
      this.newPw = this.newPw.replace(/\s/g, '');
      this.newPw2 = this.newPw2.replace(/\s/g, '');
    }
  }
}
</script>

<template>
  <div class="login-container noselect">
  <div class="logo_container noselect">
    <div class="background-login-shadow">
    <img class="logo" src="../assets/Logo_SDE_ES-Nom.png">
      <h1>Establecer contraseña</h1>
      <div class="Form-RegPwd">
        <input type="email" v-model="email" @input="isButtonActive" v-on:input="restrictEmailStringInput"
               v-on:keydown.enter="requestPwActionsExecute" v-maska data-maska="Z"
               data-maska-tokens="Z:[a-z.@_0-9]:multiple" :disabled="showResetPwOptions"
               placeholder="Ingrese su correo">
        <div v-if="showResetPwOptions">
          <input type="text" v-model="uniqueCode" @input="isButtonActive" v-on:input="restrictUniqueCodeInput"
                 placeholder="Ingrese el codigo temporal">
          <input type="password" v-model="newPw" @input="isButtonActive" v-on:input="removeSpace"
                 placeholder="Ingrese su nueva contraseña">
          <input type="password" v-model="newPw2" @input="isButtonActive" v-on:input="removeSpace"
                 placeholder="Confirme su nueva contraseña">
        </div>
        <button v-on:click="requestPwActionsExecute" v-bind:disabled="actionButton">Siguiente</button>
      </div>

    </div>
    </div>
  </div>
</template>


<style>


</style>
